<template>
  <div class="h-dialogContainer">
    <form id='addDev'>
    <div class="row h-row-inputBox">
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.devType')}}:</div>
          <ejs-dropdownlist
             name="devType"
            :placeholder="devTypePlaceholder"
            :dataSource="typeData"
            v-model="devinfo.typeCode"
            :fields="typeFields"
            :readonly="readDeviceType"
            :change="ondeviceTypeChange"
            :noRecordsTemplate="noRecordsTemplate"
            :allowFiltering='true' 
            :filtering='onFiltering' 
            :filterBarPlaceholder="filterPlaceholder"
          ></ejs-dropdownlist>
        </div>
      </div>
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.devName')}}:</div>
          <input
            name="devName"
            class="e-input"
            :placeholder="devNamePlaceholder"
            type="text"
            v-model="devinfo.name"
          />
        </div>
      </div>
    </div>
    <div class="row h-row-inputBox">
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.devSoftVersion')}}:</div>
          <ejs-dropdownlist
             name="devSoftVersion"
            :placeholder="devSoftVersionPlaceholder"
            :dataSource="visionData"
            v-model="devinfo.softwareVersion"
            :fields="visonFields"
            :readonly="readSoftware"
            :stateenabled="visonEnable"
            :change="onSoftVersionChange"
            :noRecordsTemplate="noRecordsTemplate"
          ></ejs-dropdownlist>
        </div>
      </div>
      <!-- 归属子网 -->
      <div class="col-sm-6 h-col-inputBox">
        <div v-if='true'>
          <div class="h-inputLit"><span v-if='isMCSDev' class="h-red-code">* </span>{{this.$t('Topo.devBelongSubnet')}}: <i class=" icon hero-icon hero-icon-tips e-icons" style="font-size: 14px; line-height: 14px;color: #666;" :title="deviceSubnetTips"></i></div>
          <ejs-dropdownlist
            name="devAttriTrunk"
            :placeholder="devAttriSubnetPlaceholder"
            :dataSource="subnetList"
            v-model="devinfo.subnetId"
            :fields="subnetFields"
            :readonly="readDevAttriSubnet"
            :stateenabled="visonEnable"
            :noRecordsTemplate="noRecordsTemplate"
            :showClearButton="true"
          ></ejs-dropdownlist>
        </div>
      </div>
      <div class="col-sm-6 h-col-inputBox" v-if='devAttriTrunkFlag'>
        <div>
          <div class="h-inputLit"><span v-if='isMCSDev' class="h-red-code">* </span>{{this.$t('Topo.devAttriTrunk')}}:</div>
          <ejs-dropdownlist
             name="devAttriTrunk"
            :placeholder="devAttriTrunkPlaceholder"
            :dataSource="trunkList"
            v-model="devinfo.clusterId"
            :fields="trunkFields"
            :readonly="readDevAttriTrunk"
            :stateenabled="visonEnable"
            :change="ondevAttriTrunkChange"
            :noRecordsTemplate="noRecordsTemplate"
          ></ejs-dropdownlist>
        </div>
      </div>
    </div>
      <div class="row h-row-inputBox" v-show="showLocation">
        <div class="col-sm-6 h-col-inputBox">
          <div>
            <div class="h-inputLit">{{this.$t('Topo.longitude')}}:</div>
            <input name="devLongitude" :placeholder="devLongitudePlaceholder" v-model="devinfo.longitude" type="text" class="e-input"/>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div>
            <div class="h-inputLit">{{this.$t('Topo.latitude')}}:</div>
            <input name="devLatitude" :placeholder="devLatitudePlaceholder" v-model="devinfo.latitude" type="text" class="e-input"/>
          </div>
        </div>
      </div>
      <div class="row h-row-inputBox" v-show="showLocation">
        <div class="col-sm-6 h-col-inputBox">
          <div>
            <div class="h-inputLit">{{this.$t('Topo.altitude')}}:</div>
            <input name="devAltitude" :placeholder="devAltitudePlaceholder" v-model="devinfo.altitude" type="text" class="e-input"/>
          </div>
        </div>
      </div>
     <IPAddrList ref='ipAddrList'></IPAddrList>
    <div class="row h-row-inputBox">
      <div class="h-col-inputBox" style='margin-top:18px'>
        <div class="h-inputLit">{{this.$t('Topo.devDescription')}}:</div>
        <ejs-textbox  name="devDescription" multiline="true" :placeholder="devDescriptionPlaceholder" v-model="devinfo.description"></ejs-textbox>
      </div>
    </div>
    </form>
    <div class="h-clear-rowMg"></div>
  </div>
</template>

<script>

import { FormValidator } from '@syncfusion/ej2-vue-inputs';
import IPAddrList from './IPAddrList';
import { Query } from '@syncfusion/ej2-data';
import { EventBus } from '../../plugins/eventBus';

export default {
  name: 'add-device',
  components: {
    IPAddrList,
  },
  data() {
    return {
      devNamePlaceholder: this.$t('Topo.devName'),
      devTypePlaceholder: this.$t('Topo.devType'),
      devThreadPlaceholder: this.$t('Topo.devThread'),
      devSoftVersionPlaceholder: this.$t('Topo.devSoftVersion'),
      // devSoftVersionPlaceholder:this.$t('Topo.devSoftVersion'),
      devDescriptionPlaceholder: this.$t('Topo.devDescription'),
      devAttriTrunkPlaceholder:this.$t('Topo.devSelect'),
      devAttriSubnetPlaceholder: this.$t('Topo.devAttriSubnet'),
      commuIPPlaceholder: this.$t('Topo.devIp'),   
      commuPortPlaceholder: this.$t('Topo.devPort'),
      devLongitudePlaceholder: this.$t('Topo.longitudePlaceholder'), // 经度
      devLatitudePlaceholder: this.$t('Topo.latitudePlaceholder'),  // 纬度
      devAltitudePlaceholder: this.$t('Topo.altitudePlaceholder'),
      deviceSubnetTips: this.$t('Topo.deviceSubnetTips'),
      devinfo: {
        id: '',
        name: '',
        typeCode: 0,
        subnetId: '',
        clusterId:'',
        positionX: 225,
        positionY: 226,
        longitude: '',
        latitude: '',
        altitude: '',
        ipPortData: [],
        softwareVersion: '',
        displaySoftwareVersion:'',
        description: '',
      },
      typeData: [],
      typeFields: { value: 'typeCode', text: 'nameKey' },
      visionData: [],
      visonFields: { value: 'softwareVersion', text: 'displaySoftwareVersion' },
      trunkList:[],
      subnetList: [], // 归属子网集合
      trunkFields: { value: 'clusterId', text: 'trunkName' },
      subnetFields: { value: 'id', text: 'name'},
      visonEnable: true,
      attriTrunk: false,
      readDeviceType: false,
      readSoftware: false,
      readDevAttriTrunk: false,
      readDevAttriSubnet: false,
      isMCSDev:false,
      devAttriTrunkFlag:false,
      showLocation: true, //显示位置信息
      noRecordsTemplate: this.$t('Topo.noData'),
      filterPlaceholder: this.$t('Topo.search'),
      validationOption: {
        customPlacement(inputElement, errorElement) {
            errorElement.style.float = 'left';
            inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {                    
            devType: {                        
                required: [true, `${this.$t('Pm.alertRequired')}`],
            },
            devName: {
                required: [true, `${this.$t('Pm.alertRequired')}`],
                regex: [/^(^\S)/, `${this.$t('Topo.noEmptyStart')}`],
                maxLength: [30, `${this.$t('Topo.topoMaxLength')}30`],
            },
            devSoftVersion: {
                required: [true, `${this.$t('Pm.alertRequired')}`],
            },
            devDescription: {            
                maxLength: [255, `${this.$t('Topo.topoMaxLength')}255`],
            },
            devLongitude: {
              regex: ['^(\\-|\\+)?\\d+(\\.\\d+)?$', `${this.$t('System.inputNumber')}`],
              range: [[-180, 180], `${this.$t('Topo.longitudeIllegal')}`],
            },
            devLatitude: {
              regex: ['^(\\-|\\+)?\\d+(\\.\\d+)?$', `${this.$t('System.inputNumber')}`],
              range: [[-90, 90], `${this.$t('Topo.latitudeIllegal')}`],
            },
            devAltitude: {
              regex: ['^(\\-|\\+)?\\d*$', `${this.$t('System.inputInteger')}`],
              range: [[-9999, 9999], `${this.$t('Topo.altitudeIllegal')}`],
            },
        }
      }, 
    };
  },
  mounted() {
    // this.initData();
    this.bindValidate();
  },

  // computed: {
  //   searchDataForList(val) {
  //     const searchString = this.searchString.trim();
  //     return  this.dataForList;
  //   },
  // },

  methods: {
    outputs(isFromGraph, positionX, positionY, subnetId) {   
      //校验弹窗     
      if (!this.validate()) {
        return;
      }
      //校验通信ip和端口
      const IpPortData = this.$refs.ipAddrList.getDatas();
      if(IpPortData === null){
        console.log('IpPortData === null return')
        return;
      }
      
      this.devinfo.equipmentIPList.length = 0;
      for(var k in IpPortData){
        this.devinfo.equipmentIPList.push({
            id: '', 
            ip: IpPortData[k].ipaddr, 
            port: IpPortData[k].port, 
            service:''
          }) 
      }
      const flag1234 = this.threadIDMatch(this.devinfo.typeCode);
      if(!flag1234){
        this.devinfo.equipmentIPList=[];
        return;
      }
      if(this.devinfo.typeCode === 10003 && this.devinfo.clusterId !== 'null') //有归属集群的MCS设备service是mcs
      {
         this.devinfo.equipmentIPList[0].service = 'mcs';
      }
      if (isFromGraph) {
        this.devinfo.positionX = positionX;
        this.devinfo.positionY = positionY;       
      }
      const devInfo = {
        ...this.devinfo,
        typeCode: this.devinfo.typeCode.toString(),
      }
      this.axios.post('/lte/ems/topo/device/addDev', devInfo).then((response) => {
        if(response.data === undefined){
          return;
        }
        if (response.status === 200) {
          if (response.data.errorCode === 'SUCCESS') {
            EventBus.$emit('toast', {type: 'success', content: this.$t('Track.success')});
            this.closeWindow();
            return;
          } else {
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
        }
        // this.closeWindow();
        // this.initData();
      });
    },
    ondeviceTypeChange(e) {
      const devType = parseInt(e.value);
      const This = this;
      if (devType === 10004 || devType === 10006 || devType === 10007) {
        this.showLocation = true;
      } else {
        this.showLocation = false;
      }
      const visionDataTemp=[];
      //添加设备时查软件版本，修改时不查
      // if( devType !== 10003 ){     //设备类型不为MCS10003时不允许选择归属集群，直接查设备的软件版本
        // this.formObj.removeRules('devAttriTrunk');
        This.readDevAttriTrunk = true;
        This.isMCSDev = false;
        This.devAttriTrunkPlaceholder = this.$t('Topo.noSelectTrunk'),
        This.devSoftVersionPlaceholder = this.$t('Topo.devSelect'),
        This.$axios.get(`/lte/ems/topo/device/devSoftVersion?devType=${devType}&trunkId=${'null'}`).then(response => {
          if(response.data === undefined){
            return;
          }
          if (response.status === 200) {
            if (response.data.errorCode === 'SUCCESS') {
              for(var k in response.data.resultVal) {
                visionDataTemp.push({
                    softwareVersion:k,
                    displaySoftwareVersion:response.data.resultVal[k]
                  })
              }
              This.visionData = visionDataTemp;
            } else {
              This.visionData = [];
              EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
            }
          }
        });      
    
	  //-- 切换设备类型时调整IP和端口的数量
      const args = {
        typeCode: this.devinfo.typeCode,
      }
       this.$refs.ipAddrList.initArgs(args);
       if( devType !== 10003 ){
         This.devinfo.clusterId = '';
         This.trunkList=[];
       }
    }, 

    ondevAttriTrunk() {
      const This = this;
      const trunkListTemp=[];
      This.$axios.get('/lte/ems/topo/trunk/findAllTrunks').then(response => {
        if(response.data === undefined) {
          return;
        }
        if(response.status === 200) {
          if (response.data.errorCode === 'SUCCESS') {
            for(var i in response.data.resultVal){
              trunkListTemp.push({
                clusterId:response.data.resultVal[i].id + '',
                trunkName:response.data.resultVal[i].name
              })
            };
            trunkListTemp.push({
              clusterId: 'FFFF',
              trunkName:this.$t('Topo.noAttriTrunk'),
            });
            This.trunkList = trunkListTemp;
          } else {
            This.trunkList=[];
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
        }
      });
    },

    ondevAttriTrunkChange(e){
      const This = this;
      if(e.value !== null ||this.devinfo.typeCode === 10003){   
     
      let trunkId =  e.value;
      if(e.value === 'FFFF'){
          trunkId  = 'null';
          This.devinfo.clusterId = 'null';
      }
      const visionDataTemp=[];  
      This.$axios.get(`/lte/ems/topo/device/devSoftVersion?devType=${This.devinfo.typeCode}&trunkId=${trunkId}`).then(response => {          
        if(response.data === undefined) {
          return;
        }
        if(response.status === 200) {
          if (response.data.errorCode === 'SUCCESS') {
            for(var k in response.data.resultVal){
              visionDataTemp.push({
                  softwareVersion:k,
                  displaySoftwareVersion:response.data.resultVal[k]
              })
            }
            This.visionData = visionDataTemp;
          } else {
            This.visionData = [];
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
        }
      });
      }
    },
    onSoftVersionChange(e){
      if(e.itemData !== null){
       this.devinfo.displaySoftwareVersion=e.itemData.displaySoftwareVersion;
      }  
    },
    closeWindow() {
      console.log('close');
      this.$emit('close');
    },
    // 参数pId拓扑监控使用,请佩奇姐@小朱 注意资源管理不要对pId传参
    initData(devdata, pId) {
      // 新建设备专用
      console.log('devdata',devdata)
      this.queryDevType();
        this.devinfo = {
          id: '',
          name: '',
          typeCode: '',
          clusterId:'',
          subnetId: '',
          equipmentIPList: [],
          softwareVersion: '',
          displaySoftwareVersion:'',
          description: ''
        };
      this.$refs.ipAddrList.addBtnClick('first');
       this.getSubnetList(pId);
    },

    // 新建设备时去后台查设备类型
    queryDevType() {
      const This = this;
      const params={ };
      This.$axios.get('/lte/ems/topo/device/devType',params).then((response) => {
        if(response.data === undefined) {
          return;
        }
        if( response.status === 200) {
          if (response.data.errorCode === 'SUCCESS') {
            This.typeData = response.data.resultVal;
          } else {
            This.typeData = [];
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
        }
      });
    },

    threadIDMatch(value) {
      // 设备类型与进程号绑定
       const This = this;   
      if (value === 10001 ) {
        this.devinfo.equipmentIPList[0].service = 'epc';
      }
      if (value === 10002) {
         this.devinfo.equipmentIPList[0].service = 'ims';
       }
      if (value === 10003) {
        this.devinfo.equipmentIPList[0].service = 'mcs';
      }


      if (value === 10004|| value === 10008) {
       this.devinfo.equipmentIPList[0].service = 'enodeb';
      }
      if (value === 10005 || value === 10006) {
          const len = this.devinfo.equipmentIPList.length;
          if(len === 1){
            this.devinfo.equipmentIPList[0].service = 'enodeb';
          }
          if(len === 2){
            this.devinfo.equipmentIPList[0].service = 'enodeb';
            this.devinfo.equipmentIPList[1].service = 'epc';
            if(this.devinfo.equipmentIPList[0].ip === this.devinfo.equipmentIPList[1].ip&&
            this.devinfo.equipmentIPList[0].port === this.devinfo.equipmentIPList[1].port){      
              EventBus.$emit('toast', {type: 'error', content: this.$t('Topo.ipPortDup')});
              return false;
            }
          }
          if(len === 3){
            this.devinfo.equipmentIPList[0].service = 'enodeb';
            this.devinfo.equipmentIPList[1].service = 'etc';
            this.devinfo.equipmentIPList[2].service = 'etc';
            
            if((this.devinfo.equipmentIPList[0].ip === this.devinfo.equipmentIPList[1].ip&&
            this.devinfo.equipmentIPList[0].port === this.devinfo.equipmentIPList[1].port)||
            (this.devinfo.equipmentIPList[0].ip === this.devinfo.equipmentIPList[2].ip&&
            this.devinfo.equipmentIPList[0].port === this.devinfo.equipmentIPList[2].port)||
            (this.devinfo.equipmentIPList[1].ip === this.devinfo.equipmentIPList[2].ip&&
            this.devinfo.equipmentIPList[1].port === this.devinfo.equipmentIPList[2].port)
            ){
              EventBus.$emit('toast', {type: 'error', content: this.$t('Topo.ipPortDup')});
              return false;
            }
          }
      }
      if (value === 10007) {
        this.devinfo.equipmentIPList[0].service = 'bpdt';
      }
      return true;
    },
    bindValidate() {            
      this.formObj = new FormValidator('#addDev', this.validationOption);
    },
    validate() {
      const formStatus = this.formObj.validate();
      return formStatus;
    },
    //添加IP和端口时添加校验规则 
    addAttriTrunkRules(){
      const rules1 = {                                        
          required: [true, `${this.$t('Pm.alertRequired')}`],        
        }
      this.formObj.addRules("devAttriTrunk",rules1);
    },
    onFiltering(e){
      var query = new Query();
      query = (e.text !== '') ? query.where('nameKey', 'startswith', e.text, true) : query;
      e.updateData(this.typeData, query);
    },
    getSubnetList(pId) {
      let role = false;
      this.$axios.get('/lte/ems/auth/findSystemRole').then(response => {
        if (response && response.status === 200 && response.data !== undefined) {
          role = response.data;
        }
        let username = '';
        let principal = sessionStorage.getItem('principal');
        if (!!principal) {
          let user = JSON.parse(principal);
          username = user.username;
        }
        if ((username == 'Eadmin') || role) {
          this.axios.post('/lte/ems/topo/subnet/findAllSubnet').then(response => {
            if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
              if (response.data.resultVal && response.data.resultVal.length > 0) {
                this.subnetList = response.data.resultVal;
                if (pId)
                  this.devinfo.subnetId = pId;
              }
            } else {
              console.log('查询全部子网异常!');
            }
          });
        } else {
          this.axios.get('/lte/ems/auth/findSubnetListByAuth').then(response => {
            if (response && response.status === 200) {
              if (response.data && response.data.length > 0) {
                this.subnetList = response.data;
                if (pId)
                  this.devinfo.subnetId = pId;
              }
            } else {
              console.log('查询全部子网异常!');
            }
          });
        }
      });
    },
    getDeviceType() {
      return this.devinfo.typeCode;
    },
  }
};
</script>
